export default __webpack_public_path__ + "static/media/Presentacion_webinar_Driver_Services.VF.f74ce0dd.pdf";